/* eslint-disable*/
import { AxiosResponse } from 'axios';
import { AccountManagementURLParam } from '../constants/constants';
import { APIError } from '../types/types';

const envs = ['local', 'dev', 'qa', 'uat', 'perf', 'training'];

export const sanitizeURL = (url: string): string => {
  if (!url) {
    return '';
  }

  const badURLRegex = RegExp('^((https)|(http)):/{3,}');
  const isBadURL = badURLRegex.test(url);

  if (isBadURL) {
    return 'https://' + url.replace(badURLRegex, '');
  }

  return url;
};

export const getErrorMessage = (response?: AxiosResponse<APIError>) => {
  if (response?.status === 400 && response?.data.errors[0].code) {
    return response?.data.errors[0].message;
  }

  return null;
};

export const getEnvValue = (): string => {
  const path = window.location.href;
  const envFromPath = path.substring(
    path.indexOf('://') + 3,
    path.indexOf('-')
  );
  return envs.includes(envFromPath) ? envFromPath : 'prod';
};
export const separateDay =(actualDate:string|Date)=>{
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    console.log(actualDate,'actualDate'); 
    const today = new Date(actualDate);
    return days[today.getDay()];
    
  }

export const isLandedFromAM = (pathName: string) =>
  pathName.includes(AccountManagementURLParam);

export function parseApiError(err: any) {
  const raw = err?.data?.errors?.[0]?.error;

  let parsed: any = {};
  if (typeof raw === 'string') {
    try {
      parsed = JSON.parse(raw);
    } catch {
      return { message: raw };
    }
  }

  if (raw && typeof raw === 'object') {
    parsed = raw;
  }
  return {
    message: parsed.message || 'Unknown error',
    ttl: parsed.ttl,
  };
}
